import { memo, PropsWithChildren } from 'react';
import styles from './Divider.module.scss';

export interface DividerProps {
  direction?: 'vertical' | 'horizontal';
}

export default memo(function Divider({
  direction,
}: PropsWithChildren<DividerProps>) {
  return (
    <div
      className={direction === 'vertical' ? styles.vertical : styles.horizontal}
    />
  );
});
